
import Link from 'next/link'
import { useEffect } from "react";
import { sendMessageApi } from '../lib/api'
import { useRouter } from 'next/router'

import MapSvg from './map-svg';

export default function ContactMap({siteEnv, isContact=false}) {

    
    const router = useRouter();

    var erreur;
    const sendMessage = async (e) => {
        erreur = '';
        e.preventDefault()
        /* console.log(siteEnv, site)
        return; */
        console.log(e.target.name.value);
        const result = await sendMessageApi(e.target, siteEnv);
        console.log('result', result);
        if (result['envoyé']) {
            router.push('/contact-success');
        } else {
            if (result['erreur']) {
                erreur = result['erreur'];
            } else {
                erreur = 'Erreur lors de l\'envoi du message.';
            }
            document.getElementById('erreur').innerHTML = erreur;
        }
    }

    return(
        <>
            <section className="mapContainer bg-white z-10" id="zone8">
                <MapSvg ></MapSvg>
                <div className="container grid grid-cols-1 lg:grid-cols-12 items-center z-20 ml-0">
                    <div className="col-span-1 lg:col-span-7 h-full items-center grid grid-cols-12 p-4 md:pl-24">
                        <div className="grid grid-cols-12 col-span-12">
                            <div className='col-span-12'>
                                
                            {isContact? 
                                (<h1 className="text-5xl text-color-primary mb-6 font-light">Contactez-nous</h1>) 
                                :
                                (<p className="text-5xl text-color-primary mb-6 ">Contactez-nous</p>)
                            }
                            </div>
                            <div className="col-span-12 p-0 mb-10 grid grid-cols-12">
                                <form onSubmit={sendMessage} className="col-span-12 lg:col-span-7" /* method="post" id="monForm" action="/contact" */>
                                    <div className="">
                                        <div className="w-full">
                                            <div>
                                                <label htmlFor="name" className="color-primary"></label>
                                                <input name="name" type="text" className="input-user bg-color-transparent placeholder-grey w-full mb-2 color-grey border border-grey p-2" placeholder="Nom"  required="" />
                                            </div>
                                            <div>
                                                <label htmlFor="email"></label>
                                                <input name="email" type="text" className="input-mail bg-color-transparent placeholder-grey w-full mb-2 color-grey border border-grey p-2" placeholder="Email"  required="" />
                                            </div>
                                            <div>
                                                <label htmlFor="tel"></label>
                                                <input name="tel" type="text" className="input-phone bg-color-transparent placeholder-grey w-full mb-2 color-grey border border-grey p-2" placeholder="Téléphone"  required="" />
                                            </div>
                                        </div>
                                        <div className=" w-full">
                                            <div>
                                                <label htmlFor="message"></label>
                                                <textarea name="message" className="text-form bg-color-transparent w-full color-grey border placeholder-grey border-grey p-2 mb-2" placeholder="Votre message" required=""></textarea>
                                            </div>
                                            <div className="flex items-center">
                                                {/* <span className="w-full"><hr className="contact-hr border-grey"/></span> */}
                                                <input type="submit" name="submit" id="submit" className="bg-color-transparent text-grey w-auto color-grey border border-grey transition duration-500 ease-in-out hover:border-color-primary hover:bg-color-primary hover:text-white px-6 py-2" value="Envoyer" required="" />
                                                
                                            </div>
                                        </div>
                                    </div> 
                                </form>
                            </div>
                            <div className="col-span-12 p-0 mb-10">
                                <p className="contact_title"><i className="fa fa-phone-alt icon" aria-hidden="true"></i> Appellez <span>nous</span></p>
                                <p className="phone-number">01 47 70 19 74</p>
                            </div>
                            <div className="col-span-12 p-0 mb-10 grid grid-cols-12">
                                <p className="contact_title col-span-12"><i className="fa fa-map-marker-alt icon" aria-hidden="true"></i> Venez nous <span>rencontrer</span></p>
                                <p className="coord  col-span-12"></p>
                                <ul className="no-padding col-span-12">
                                    <li>5 rue Ponscarme - 75013 Paris</li>
                                    <li>
                                        <img src="/img/metro.png" style={{width:"15px", marginRight:"3px"}} alt="logo metro"/><img src="/img/metro14.png" alt="logo metro ligne 14" style={{width:"17px", marginRight:"8px"}}/>
                                            Métro Olympiades
                                    </li>
                                </ul>
                                <ul className="col-span-6 lg:col-span-3 xl:col-span-4 no-padding hidden-sm-down">
                                    <li><a className="link-plus" target="_blank" rel="noreferrer noopener" alt="position alphalives" href="https://www.google.fr/maps/place/5+Rue+Ponscarme,+75013+Paris/@48.8266,2.3660331,17z/data=!3m1!4b1!4m5!3m4!1s0x47e672263910be1f:0x349dee3fc4f9c9ce!8m2!3d48.8266!4d2.3682218">Calculer votre itinéraire</a></li>
                                </ul>
                                {/* <div className="hidden-sm-down col-span-6 lg:col-span-3 link-hr"></div> */}
                                <p></p>
                            </div>
                        </div>
                        
                    </div>
                
                </div>
            </section>
        </>
    )
}